import { useEffect, useReducer, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { DataDogVitals } from 'utilities/helpers/dataDog.vitals.js';
import { PageChangeContext } from './page-change-context.js';

/**
 * Only updates when page transition has happened NOT on first page change
 * At start state will be 0, then page change state will be either 1 or two.
 * Can check if page has changed wuth useEffect
 */
export const PageChangeProvider = ({ children }: { children: JSX.Element }) => {
  const { pathname } = useLocation();
  const previousPathsRef = useRef<string[]>([]);
  const [pageUrlChanged, setPageUrlChanged] = useReducer<React.ReducerWithoutAction<symbol | undefined>>(
    () => Symbol('change'),
    undefined,
  );

  useEffect(() => {
    if (pathname) {
      const previousPaths = previousPathsRef.current;
      const recentPreviousPath = previousPaths[previousPaths.length - 1];
      if (!recentPreviousPath) {
        /** First time url */
        previousPathsRef.current = [pathname];
      } else {
        if (recentPreviousPath !== pathname) {
          previousPathsRef.current = [...previousPathsRef.current, pathname];
          setPageUrlChanged();
          DataDogVitals['AdDomBannerNav'].start();
        }
      }
    }
  }, [pathname]);

  /** If number is 1 or 2 page has changed */
  return <PageChangeContext.Provider value={{ pageUrlChanged }}>{children}</PageChangeContext.Provider>;
};
